import React from "react";

const Header = ({ translations, logo, logoLoading }) => {
  return (
    <div className="text-center">
      {logoLoading && (
        <div
          style={{
            height: "100px",
            width: "100px",
            marginTop: "10px",
            margin: "10px auto 0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div className="spinner-border" role="status"></div>
        </div>
      )}
      {!logoLoading && (
        <img
          src={logo ||  "https://washi.s3.amazonaws.com/Almata-blue.png"}
          alt={translations.almataLogo}
          style={{
            height: "100px",
            width: "100px",
            marginTop: "10px",
            objectFit: "contain",
            filter: "drop-shadow(0 0 8px rgba(0,0,0,0.3))",
          }}
          className="mb-0"
        />
      )}
      <h4 className="fw-bold mt-0">{translations.mainTitle}</h4>
      <p
        className="text-muted mx-auto"
        style={{ maxWidth: "810px", fontSize: "15px" }}
      >
        {translations.mainDescription}
      </p>
    </div>
  );
};

export default Header;
